import { Component, Input, Output } from '@angular/core';
import { NavController, LoadingController, MenuController, ToastController, Alert, NavParams } from 'ionic-angular';
import { Subject } from 'rxjs';
import { debounceTime, take } from 'rxjs/operators';
import { PatientService } from '../../services/patient.service';
import { Empresa, EmpresaApi, Medicion, MedicionApi, Paciente, SucursalApi, UsuarioApi } from '../../services/lbsdk';
import { FichaTabsPage } from '../ficha-tabs/ficha-tabs';
import { Constants } from '../../constants';
import { CompaniesProvider } from '../../providers/companies/companies.provider';
import { AuthService } from '../../services/auth/auth.service';
import { LoginPage } from '../login/login';
import { HttpClient, HttpHeaders } from '@angular/common/http';


import { Observable } from 'rxjs';
import * as XLSX from 'xlsx';
import { v } from '@angular/core/src/render3';
// if you use typescript

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  textoMostrar: string = "";
  cargando = false;
  /* PAGINADOR */
  empresasPermitidas = []
  estados;
  estado;
  externo;
  public cantidades = [];
  mostrarFoto = false;
  empresa;

  sucursales;
  sucursal;

  public paginationInfo = {
    page: 1,
    pageSize: 0,
    rowCount: 0,
    pageCount: 0,
  }

  patients: Medicion[] = [];
  patientsFromServer: Medicion[] = [];
  private subject: Subject<string> = new Subject<string>();
  sortReverse: boolean = false;
  sortField: string = 'created';
  sortType: string = 'DESC';
  public searchKey: string = '';
  //codigoVendedor: number;
  urlApi;
  fieldVisible = {
    id: true, name: true, lastname: true, number: true, recipe: true,
    company: true, created: true, avatar: true, state: true, codigoVendedor: true, descripcion: true, State: true
  }
  searchToast: any;
  codigoVendedor: string = "";
  identificador: string = "";
  admin;
  offset
  constructor(public navCtrl: NavController, public patientServiceSdk: PatientService,
    private loading: LoadingController, public menuCtrl: MenuController,
    private companyService: CompaniesProvider, private authService: AuthService,
    private customUser: UsuarioApi, private toastController: ToastController, private http: HttpClient,
    private patientSdk: PatientService, private medicionApi: MedicionApi, private sucursalApi: SucursalApi,
    private empresaApi: EmpresaApi, public navParams: NavParams) {
    this.urlApi = Constants.hostApiNode

    this.offset = new Date().getTimezoneOffset();

  }




  // cambioEmpresaHeader(empresa)
  // {
  //   alert("Home " + JSON.stringify(empresa))
  // }
  ionViewCanEnter() {
    if (!this.authService.isLoggedIn()) {
      this.navCtrl.setRoot(LoginPage)
    }
    this.subject.pipe(
      debounceTime(200))
      .subscribe(searchTextValue => {
        this.searchKey = searchTextValue;
        this.handleSearch(searchTextValue);


      });


  }
  refrescar() {
    this.resetPaginador();
    this.handleSearch(this.searchKey);
  }
  onKeyUp(event) {

    if (event.target.value.toString().length > 3) {
      const searchKey = event.target.value;
      this.subject.next(searchKey);
    }

    if (event.target.value.toString().length == 0) {
      const searchKey = event.target.value;
      this.subject.next(searchKey);
    }

  }
  resetPaginador() {

    this.paginationInfo.page = 1;
  }
  onSearchButton() {
    this.resetPaginador();
    this.handleSearch(this.searchKey);
  }
  openMenu() {
    this.menuCtrl.enable(true, 'myMenu');

    this.menuCtrl.open();
  }
  recargar() {
    this.handleSearch(this.searchKey);

  }
  ionViewDidLoad() {
    // alert("ok")
    this.cantidades = [
      { id: 10, name: 10 },
      { id: 30, name: 30 },
      { id: 50, name: 50 },
      { id: 100, name: 100 }
    ]



    this.admin = this.authService.isAdministrador();

    /*this.empresaApi.findById(1).subscribe(res => {
      this.empresa = res;
      this.handleSearch
    })*/

    this.patientServiceSdk.getState()
      .subscribe(est => {
        est.push({ idEstado: 0, descripcion: "Todos" })
        this.estados = est;
        this.estado = { idEstado: 1, descripcion: "Pendiente" };
        this.paginationInfo = {
          page: 1,
          pageSize: 10,
          rowCount: 0,
          pageCount: 0,
        }
        this.filtrarSucursales();
        this.sucursal = { idsucursal: "0", nombre: "Todas" };
        // this.sucursales = this.sucursal;
        // this.sucursal = { idsucursal: "0", nombre: "Todas" };
        this.handleSearch(this.searchKey);
        /*this.sucursalApi.find()
          .subscribe(res => {

            res.push({ id: "0", nombre: "Todas" })
            this.sucursales = res;
            this.sucursal = { idsucursal: "0", nombre: "Todas" };
            this.filtrarSucursales();
            this.handleSearch(this.searchKey);

          })*/

      })
  }
  onSearchButton2() {
    this.patientServiceSdk.count({ "or": [{ "name": { "like": "", "options": "i" } }, { "lastname": { "like": "", "options": "i" } }], "and": [{ "state": 1 }] })
      .subscribe(respuesta => {
        console.log(respuesta)
      })
  }
  filtrarEmpresas() {

    //TODO:
    /*this.empresasPermitidas = [];
    if (!this.authService.isAdministrador()) { //(this.authService.userData.user.gerencia == false) {
      this.customUser.findOne({ where: { idusuario: this.authService.userData.userId }, include: { "Company": "Empresa" } })
        .subscribe(companyUser => {
          this.empresas.forEach(element => {
            const dejarEmpresa = companyUser['Company'].find(yaEsta => yaEsta.idCompany == element.id);
            if (!dejarEmpresa && element.id != "0") {
              this.empresas = this.empresas.filter(yaEsta => yaEsta.id != element.id);
            }
            else if (element.id == "0") {

            }
            else {
              this.empresasPermitidas.push(dejarEmpresa.idCompany)
            }
          });
          this.handleSearch(this.searchKey);
        })
    }
    else {
      this.empresas.forEach(element => {
        this.empresasPermitidas.push(element.id)
      })
      this.handleSearch(this.searchKey);
    }*/
  }
  filtrarSucursales() {
    this.sucursales = [];
    console.log("ADMINISTRADOR ", this.authService.isSuperAdministrador())
    if (!this.authService.isSuperAdministrador()) { //(this.authService.userData.user.gerencia == false) {
      //   alert(this.authService.empresaSeleccionada + " empresa seleccionada")
      this.sucursales = this.authService.userData.sucursales.filter(x => x.idempresa == this.authService.empresaSeleccionada)//this.empresa.idEmpresa);
      console.log("FILTRO SUCURSALES ", this.sucursales);
      console.log(this.sucursal);
      this.sucursales.push({ idsucursal: 0, nombre: "Todas" });
      this.sucursal = { idsucursal: 0, nombre: "Todas" }


    }
    //if (this.sucursales.length > 0) {
    else {

      this.sucursalApi.find({
        where:
          { idempresa: this.authService.empresaSeleccionada }//this.empresa.idEmpresa }
      }).subscribe(respuesta => {

        this.sucursales = respuesta;
        this.sucursales.push({ idsucursal: 0, nombre: "Todas" });
        this.sucursal = { idsucursal: 0, nombre: "Todas" }

      })
    }
    // this.sucursales = this.sucursales.filter(x => x.idempresa == this.empresa.idEmpresa);

    //}






  }

  async verInforme(result) {
    const loadingMessage = await this.loading.create();
    loadingMessage.present();
    let parameter = "IDMEDICION=" + result.IdMedicion
    this.http.post(Constants.hostApiNode + "/api/ConsultasSqls/GetReportPdf", { nameReport: "rptInforme", queryParameter: parameter, movil: true })
      .subscribe(respuesta => {
        loadingMessage.dismiss();
        console.log("REPUESTA PDF", respuesta)

        var byteCharacters = atob(respuesta['$data']);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        var file = new Blob([byteArray], { type: 'application/pdf;base64' });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        //alert(JSON.stringify(respuesta))
        //console.log(this.file.dataDirectory)
        //ABRIR PDF 
        /*this.file.createFile(this.file.dataDirectory, result.IdMedicion + '.pdf', true).then((response) => {
          console.log('file created', response);

          const byteCharacters = atob(respuesta['$data']);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'application/pdf' });

          this.file.writeExistingFile(this.file.dataDirectory, result.IdMedicion + '.pdf', blob).then((response) => {
            console.log('successfully wrote to file', response);
            /*this.fileOpener.open(this.file.dataDirectory + item.CheckListID + '.pdf', 'application/pdf').then((response) => {
              console.log('opened PDF file successfully', response);*/

      }, error => {
        console.log('Error creating file', error);
        alert("En este momento no es posible generar el Pdf. (Cód 03): " + error)
      });

  }
  getEstado(state) {
    if (state == 1) {
      return "Pendiente"
    }
    else if (state == 2) {
      return "Medido"
    }
    else if (state == 3) {
      return "En Fabricación"
    }
    else if (state == 4) {
      return "Enviado"
    }
    else if (state == 5) {
      return "Terminado"
    }
    else if (state == 6) {
      return "Cancelado"
    }
  }
  public handleSearch(searchKey: string) {
    if (this.cargando) return;
    this.textoMostrar = "Aguarde mientras se consultan los datos"
    this.cargando = true;
    //alert("MAL")
    let sucursal = 0

    console.log(" SUCURSAL OBJ ", this.sucursal)
    if (this.sucursal) {
      sucursal = this.sucursal.idsucursal
    }
    console.log(" SUCURSAL ", sucursal)
    this.presentSearchToast();
    let data = {
      ESTADO: this.estado.idEstado, IDSUCURSAL: this.sucursal.nombre == 'Todas' ? 0 : sucursal,
      CODIGOVENDEDOR: this.codigoVendedor.toUpperCase(),
      PAGESIZE: this.paginationInfo.pageSize, PAGENUMBER: this.paginationInfo.page - 1, NOMBRE: searchKey,
      IDUSUARIO: this.authService.userData.userId, IDEMPRESA: this.authService.empresaSeleccionada, IDENTIFICADOR: this.identificador//this.empresa.idEmpresa
    }

    console.log
    this.patientServiceSdk.findSqlStore(data)
      .subscribe((respuesta: any) => {
        this.hideSearchToast();
        this.cargando = false;

        this.paginationInfo.rowCount = respuesta[0].total;
        this.paginationInfo.pageCount = respuesta[0].total_pages;

        console.log(this.paginationInfo)

        //     this.paginationInfo.pageCount = Math.ceil((this.paginationInfo.rowCount / this.paginationInfo.pageSize))
        //     //this.paginationInfo.page = this.paginationInfo.page

        respuesta[0].data.forEach(element => {
          console.log(element)
          element.avatar = Constants.urlFotos + element.IdMedicion + '/download/avatar.jpeg';
          /* this.patientServiceSdk.findById(element.IdMedicion, { fields: { avatar: true } })
             .subscribe((respuesta: any) => {
             
               if (element.idMongo != null){
                 element.avatar = Constants.urlFotos + element.idMedicion + '/download/avatar.jpeg';
               }
               else{
                 element.avatar = Constants.urlFotos + element.idMedicion + + '/download/avatar.jpeg';
               }
               //respuesta.avatar;
             })*/

        });
        this.patients = respuesta[0].data;

      }, error => {
        this.cargando = false;
        this.hideSearchToast();
      })
  }


  // public handleSearch(searchKey: string) {
  //   let filtro = {};
  //   let where = {};

  //   if (this.estado.id != 0) {
  //     where['and'] = [{ state: this.estado.id }]
  //   }

  //   //property: { inq: [val1, val2, ...]}
  //   //alert(JSON.stringify(this.empresasPermitidas))

  //   if (this.empresa.id != "0") { //SI APLICO UN FILTRO
  //     if (where['and']) {
  //       where['and'].push({ company: this.empresa.name })
  //     }
  //     else {
  //       where['and'] = [{ company: this.empresa.name }]
  //       //where['company'] = this.empresa.name;//where['and'].push({ empresa: { inq: this.empresasPermitidas } })
  //     }

  //   } //SI BUSCA POR TODOS
  //   else {
  //     // where['and'] = { company: this.empresa.name }
  //   }

  //   if (this.codigoVendedor != "") {

  //     if (where['and']) {
  //       where['and'].push({ codigoVendedor: this.codigoVendedor.toUpperCase() })
  //     }
  //     else {
  //       where['and'] = [{ codigoVendedor: this.codigoVendedor.toUpperCase() }]
  //       //where['company'] = this.empresa.name;//where['and'].push({ empresa: { inq: this.empresasPermitidas } })
  //     }

  //   }

  //   where['or'] = [
  //     {
  //       "name": {
  //         "like": '%' + searchKey + '%'
  //       }
  //     },
  //     { "lastname": { "like": '%' + searchKey + '%' } },
  //   ] 
  //   console.log(`handleSearch:  ${searchKey}`, this.paginationInfo)
  //   let observable

  //   this.presentSearchToast();
  //   filtro['where'] = where;

  //   observable = this.patientServiceSdk.countSql(where)

  //   observable.subscribe(res => {
  //     //console.log("patients count ->>>", res);

  //     this.paginationInfo.rowCount = res.count;
  //     this.paginationInfo.pageCount = Math.ceil((this.paginationInfo.rowCount / this.paginationInfo.pageSize))
  //     //this.paginationInfo.page = this.paginationInfo.page
  //     //  let pageAux = this.paginationInfo.page == 1 ? 0 : this.paginationInfo.page

  //     let pageAux = this.paginationInfo.page == 1 ? 0 : this.paginationInfo.page

  //     filtro['where'] = where;
  //     //  filtro['include'] = "State";
  //     filtro['fields'] = this.fieldVisible;
  //     filtro['limit'] = this.paginationInfo.pageSize;
  //     filtro['skip'] = pageAux == 0 ? 0 : ((pageAux - 1) * this.paginationInfo.pageSize)
  //     filtro['order'] = `${this.sortField} ${this.sortType}`;
  //     //  this.http.post(Constants.hostApiNode + '/api/Patients/GetPacientes', filtro)
  //     this.patientServiceSdk.findSql(filtro)       
  //       .subscribe((patients: Patient[]) => {
  //         this.patients = patients;
  //         this.hideSearchToast();
  //         // loader.dismiss();
  //       }, error => {
  //         console.log(error);
  //         this.hideSearchToast();
  //       })

  //   }, error => {
  //     console.log("error");
  //     this.hideSearchToast();
  //   })/*loader.dismiss()*/
  // }


  editar(result) {

    /*this.patientSdk.findById(result.idMongo, null).subscribe(res => {
      this.navCtrl.setRoot(FichaTabsPage, { result: res });
    })
    return;*/
    console.log("DATOS ", result.IdMedicion)
    // this.patientSdk.findMedicionSql({ where: { idMedicion: result.idMedicion } })
    this.medicionApi.findById(result.IdMedicion)
      .subscribe((respuesta: Medicion) => {
        let medicion: Medicion = respuesta
        console.log("DATOS FIND ", respuesta)

        let data = {
          idMedicion: medicion.idmedicion,
          _id: medicion.idMongo,
          id: medicion.idMongo,
          company: medicion.company,
          emailCompany: medicion.emailcompany,
          name: medicion.name,
          lastname: medicion.lastname,
          number: medicion.number,
          recipe: {
            frameModel: medicion.recipeframemodel,
            framePicture: medicion.recipeframepicture,
            recipePicture: medicion.reciperecipepicture,
            recipe: medicion.reciperecipe
          },
          image: medicion.image,
          result: {
            markers: {
              left: [
                medicion.resultmarkersleft1,
                medicion.resultmarkersleft2
              ],
              right: [
                medicion.resultmarkersright1,
                medicion.resultmarkersright2
              ]
            },
            pupils: {
              left: [
                medicion.resultpupilsleft1,
                medicion.resultpupilsleft2
              ],
              right: [
                medicion.resultpupilsright1,
                medicion.resultpupilsright2
              ]
            },
            frame: {
              top: {
                left: [
                  medicion.resultframetopleft1,
                  medicion.resultframetopleft2
                ],
                right: [
                  medicion.resultframetopright1,
                  medicion.resultframetopright2
                ]
              },
              bot: {
                left: [
                  medicion.resultframebotleft1,
                  medicion.resultframebotleft2
                ],
                right: [
                  medicion.resultframebotright1,
                  medicion.resultframebotright2
                ]
              }
            },
            noseBridge: {
              top: [
                medicion.resultnosebridgetop1,
                medicion.resultnosebridgetop2
              ],
              bot: [
                medicion.resultnosebridgebot1,
                medicion.resultnosebridgebot2
              ]
            },
            mmCameraDistance: medicion.resultmmcameradistance,
            pxMarkersDistance: medicion.resultpxmarkersdistance,
            pxPupilsDistance: medicion.resultpxpupilsdistance,
            pxLeftPupilToBridge: medicion.resultpxleftpupiltobridge,
            pxRightPupilToBridge: medicion.resultpxrightpupiltobridge,
            pxLeftPupilToTopFrame: medicion.resultpxleftpupiltotopframe,
            pxLeftPupilToBotFrame: medicion.resultpxleftpupiltobotframe,
            pxRightPupilToTopFrame: medicion.resultpxrightpupiltotopframe,
            pxRightPupilToBotFrame: medicion.resultpxrightpupiltobotframe,
            mmTotalPupilDistance: medicion.resultmmtotalpupildistance,
            mmMarkersDistance: medicion.resultmmmarkersdistance,
            mmPupilsDistance: medicion.resultmmpupilsdistance,
            mmLeftPupilToBridge: medicion.resultmmleftpupiltobridge,
            mmRightPupilToBridge: medicion.resultmmrightpupiltobridge,
            mmLeftPupilToTopFrame: medicion.resultmmleftpupiltotopframe,
            mmLeftPupilToBotFrame: medicion.resultmmleftpupiltobotframe,
            mmRightPupilToTopFrame: medicion.resultmmrightpupiltotopframe,
            mmRightPupilToBotFrame: medicion.resultmmrightpupiltobotframe,
          },
          created: medicion.created,
          avatar: "",
          empresa: medicion.empresa,
          state: this.estado.idEstado,
          nroSobre: medicion.nrosobre,
          nroArreglo: medicion.nroarreglo
        }
        console.log("RESULTADO ", data)
        //  alert("PASA DATOS" + JSON.stringify(data))
        this.navCtrl.setRoot(FichaTabsPage, { result: data });

      }, error => {
        console.log("eeror al recuperadr datos")
      })



  }

  setOrder(field: string) {
    this.sortField = field;
    this.sortReverse = !this.sortReverse;
    this.sortType = this.sortReverse ? ' DESC' : ' ASC';
    this.handleSearch(this.searchKey);
  }

  /* PAGINADOR */

  changePage(valor) {
    let pageAux = this.paginationInfo.page == 1 ? 0 : this.paginationInfo.page
    this.paginationInfo.page = valor;
    this.handleSearch(this.searchKey);

  }
  cambioEstado($event) {
    this.resetPaginador();
    this.handleSearch(this.searchKey);
  }

  cambiarSucursal($event) {
    //TODO: 
    this.resetPaginador();
    this.handleSearch(this.searchKey);
  }

  filterByKey(key: string) {
    this.patients = this.patientsFromServer.filter(p =>
      p.name.toLowerCase().includes(key) ||
      p.lastname.toLowerCase().includes(key));
    console.log("pacientes filtrados ->  " + JSON.stringify(this.patients));
  }

  presentSearchToast() {
    if (this.searchToast != null) return;


    this.searchToast = this.toastController.create({
      message: "Consultado pacientes, espere un momento.",
      position: 'center',
      cssClass: 'my-toast'
    });


    this.searchToast.onDidDismiss(() => {
      console.log('Dismissed toast');
    });

    //  this.searchToast.present();
  }

  presentMensaje(mensaje) {
    if (this.searchToast != null) return;
    this.searchToast = this.toastController.create({
      message: mensaje,
      position: 'center'
    });


    this.searchToast.onDidDismiss(() => {
      console.log('Dismissed toast');
    });

    this.searchToast.present();
  }

  presentExport() {
    if (this.searchToast != null) return;
    this.searchToast = this.toastController.create({
      message: "Exportando datos, espere un momento.",
      position: 'center'
    });


    this.searchToast.onDidDismiss(() => {
      console.log('Dismissed toast');
    });

    this.searchToast.present();
  }

  hideSearchToast() {
    if (this.searchToast !== null) {
      this.searchToast.dismiss();
      this.searchToast = null;
    }
  }
  cambioPageSize($data) {
    console.log("CAMBIO DE CANTIDAD DE FILAS", $data);
    this.paginationInfo.pageSize = $data.value.id;
    this.handleSearch(this.searchKey);
  }

  async exportToExcel(data, filename) {
    console.log("***** EXPORTAR ", data)

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, filename);
    XLSX.writeFile(wb, filename + '.xlsx');
  }

  async exportar() {



    let filtro = {};
    let where = {};
    this.textoMostrar = "Aguarde mientras se exportan los datos"

    if (this.estado.idEstado != "0") {
      where['and'] = [{ idestado: this.estado.idEstado }]
    }






    if (this.sucursal.idsucursal != "0") { //SI APLICO UN FILTRO
      if (where['and']) {
        where['and'].push({ company: this.sucursal.nombre })
      }
      else {
        where['and'] = [{ company: this.sucursal.nombre }]
        //where['company'] = this.empresa.name;//where['and'].push({ empresa: { inq: this.empresasPermitidas } })
      }

    } //SI BUSCA POR TODOS
    else {
      /*const sucursalIds = this.authService.userData.sucursales.map(s => s.idsucursal);
      if (where['and']) {
        where['and'].push({ idsucursal: { inq: sucursalIds } });
      }
      else {
        where['and'] = [{ idsucursal: { inq: sucursalIds } }]
        //where['company'] = this.empresa.name;//where['and'].push({ empresa: { inq: this.empresasPermitidas } })
      }*/
      let sucursales = await this.sucursalApi.find({ where: { idempresa: this.authService.empresaSeleccionada } }).toPromise()
      const ids = sucursales.map((s: any) => s.idsucursal);
    
      if (where['and']) {
        where['and'].push({
        idsucursal: { inq: ids }
      });
      }
      else {
        where['and'] = [{
        idsucursal: { inq: ids }
      }]
        //where['company'] = this.empresa.name;//where['and'].push({ empresa: { inq: this.empresasPermitidas } })
      }
    }

    if (this.codigoVendedor != "") {

      if (where['and']) {
        where['and'].push({ codigoVendedor: this.codigoVendedor.toUpperCase() })
      }
      else {
        where['and'] = [{ codigoVendedor: this.codigoVendedor.toUpperCase() }]
        //where['company'] = this.empresa.name;//where['and'].push({ empresa: { inq: this.empresasPermitidas } })
      }

    }
    if (where['and']) {

      where['and'].push({
        or: [
          {
            "name": {
              "like": '%' + this.searchKey + '%'
            }
          },
          { "lastname": { "like": '%' + this.searchKey + '%' } },
        ]
      })

    }
    else {
      where['and'] = [{
        or: [
          {
            "name": {
              "like": '%' + this.searchKey + '%'
            }
          },
          { "lastname": { "like": '%' + this.searchKey + '%' } },
        ]
      }]
    }


    let observable
    if (this.cargando) return;

    this.cargando = true;
    this.presentExport();
    filtro['where'] = where;
    filtro['fields'] = { resultmmleftpupiltobridge: true, resultmmrightpupiltobridge: true, name: true, lastname: true, company: true, created: true, codigovendedor: true, frameModel: true, state: true, number: true }
    /*let data = {
      ESTADO: this.estado.id, EMPRESA: this.empresa.name == 'Todas' ? '' : this.empresa.name,
      CODIGOVENDEDOR: this.codigoVendedor.toUpperCase(),
      PAGESIZE: this.paginationInfo.pageSize, PAGENUMBER: this.paginationInfo.page - 1, NOMBRE: searchKey
    }*/

    // this.patientServiceSdk.findSql({
    //   where: {
    //     and: [{ state: this.estado.id }]
    //   }
    //   , fields: { name: true, lastname: true, company: true, created: true, codigoVendedor: true, frameModel: true, state: true }
    // })
    console.log(filtro)
    this.patientServiceSdk.findSql(filtro)
      .subscribe((respuesta: any) => {

        this.cargando = false;

        respuesta.forEach(element => {
          //console.log("ELEMENTO EXPORTACION ", element)
          element['Fecha'] = element.created;
          element['Identificador'] = element.number;
          element['Nombre'] = element.name;
          element['Apellido'] = element.lastname;
          element['Empresa'] = element.company;
          element['CodigoVendedor'] = element.codigovendedor;
          element['DistanciaIzquierda'] = element.resultmmleftpupiltobridge;
          element['DistanciaDerecha'] = element.resultmmrightpupiltobridge;
          //  element['Modelo'] = element.frameModel;
          if (element.state == "1") {
            element['Estado'] = "PENDIENTE"
          }
          else if (element.state == "2") {
            element['Estado'] = "MEDIDO"
          }
          else if (element.state == "3") {
            element['Estado'] = "EN FABRICACION"
          }
          else if (element.state == "4") {
            element['Estado'] = "ENVIADO"
          }
          else if (element.state == "5") {
            element['Estado'] = "TERMINADO"
          }
          else if (element.state == "6") {
            element['Estado'] = "CANCELADO"
          }
          delete element.created
          delete element.number
          delete element.name
          delete element.lastname
          delete element.company
          delete element.codigovendedor
          delete element.frameModel
          delete element.state
          delete element.resultmmleftpupiltobridge
          delete element.resultmmrightpupiltobridge
        });

        this.exportToExcel(respuesta, "Pacientes")
        this.hideSearchToast();
      }, error => {
        this.hideSearchToast();
        this.cargando = false;
      })

  }
  cambioEmpresa($event): void {
    this.resetPaginador();
    console.log("EMPRESA SELECCIONADA ", $event)
    //alert(JSON.stringify($event));
    console.log("SUCURSALES USUSARIO ", this.authService.userData.sucursales)
    //alert("DETECTA CAMBIO DE EMPRESA")

    this.sucursal = { idsucursal: "0", nombre: "Todas" };


    this.filtrarSucursales();


    this.handleSearch(this.searchKey);

  }



}



export class paginationInfo {
  page: number;
  pageSize: number;
  rowCount: number;
  pageCount: number;
}


// WEBPACK FOOTER //
// ./src/pages/home/home.ts